module.exports = __webpack_public_path__ + "static/img/shiye_img1@2x.2f98a137.jpg";